import React, { useEffect, useState } from 'react';
import ThemeToggle from './ThemeToggle';

const LINKS = [
  ['experience', 'Experience'], ['skills', 'Skills'], ['projects', 'Projects'],
  ['github', 'GitHub'], ['school', 'School'],
];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - (id === 'hero' ? 0 : 64);
  window.scrollTo({ top, behavior: 'smooth' });
}

export default function Nav() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const sections = LINKS.map(([id]) => document.getElementById(id)).filter(Boolean);
    const onScroll = () => {
      const y = window.scrollY + window.innerHeight * 0.35;
      let current = null;
      for (const s of sections) if (s.offsetTop <= y) current = s.id;
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className="nav" aria-label="Main navigation">
      <div className="container nav__inner">
        <button className="nav__brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <i /> <span>yousef.dev</span>
        </button>
        <div className="nav__bar">
          <ul className="nav__list">
            {LINKS.map(([id, label]) => (
              <li key={id}>
                <button className={`nav__link${active === id ? ' nav__link--active' : ''}`} onClick={() => scrollToId(id)}>
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="nav__right"><ThemeToggle /></div>
      </div>
    </nav>
  );
}
